import Typography from "style-guide/component/Typography";
import PaymentMethods from "./PaymentMethods";
import InvoicesTable from "./InvoicesTable";
import PlanCards from "./Plans";

const Billing = () => {

  return (
    <div className="px-6 space-y-6 bg-white">
      {/* Header Section */}
      <Typography variant="Heading 3" text="Billing & Invoices" />
      <PlanCards />
      <PaymentMethods />
      <InvoicesTable />
    </div>
  );
};

export default Billing;
